import { useHelpText, useHelpTextProps } from './use-help-text'

export type HelpTextProps = useHelpTextProps

const HelpText = (props: HelpTextProps) => {
  const { className, children, styles, componentProps } = useHelpText(props)

  return (
    <span className={styles.base({ className })} {...componentProps}>
      {children}
    </span>
  )
}

export default HelpText
